import * as DOMPurify from 'dompurify';

export class SanitizeUtil {

    static sanitizeHtml(html: string): string {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-call,@typescript-eslint/no-unsafe-return
        return DOMPurify.sanitize(html);
    }
}
